import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'common/components';
import { required } from 'common/form-validators';
import { capitalizeString } from 'common/utils';
import { OTHER_ACTIVITY_TYPES } from 'common/constants';

const TypeField = ({ submitting, disabled }) => {
  const typeOption = Object.keys(OTHER_ACTIVITY_TYPES)
    .filter(key => key !== 'HARVESTING')
    .map(key => OTHER_ACTIVITY_TYPES[key])
    .map(type => ({ label: capitalizeString(type), value: type }));
  return (
    <Select
      name="type"
      disabled={submitting || disabled}
      title="Type"
      options={typeOption}
      validate={[required]}
    />
  );
};

TypeField.propTypes = {
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
};
export default TypeField;



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/fields/TypeField.js